import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { Client, getClient } from '@monorepo-channels/channels/domain'
import { Store } from '@ngrx/store'
import { SelectCardOptionsComponent } from './select-card-options/select-card-options.component'
import { RegisterOrLoginComponent } from '../simple-bottom-sheets/register-or-login.component'
import { MatDialog } from '@angular/material/dialog'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { isMobile } from '@monorepo-channels/shared/util-helpers'

@Component({
	standalone: true,
	selector: 'feature-pm-select-card',
	imports: [CommonModule, MatIconModule],
	templateUrl: './select-card.component.html',
	styleUrls: ['./select-card.component.scss'],
})
export class SelectCardComponent {
	private store = inject(Store)
	public client$ = this.store.select(getClient)
	private dialog = inject(MatDialog)
	private bottomSheet = inject(MatBottomSheet)
	isMobile = isMobile()

	constructor() {}

	openSelectCardOptions(client: Client | null) {
		if (this.isMobile) {
			if (!client) {
				this.bottomSheet.open(RegisterOrLoginComponent)
				return
			}
			this.bottomSheet.open(SelectCardOptionsComponent)
		} else {
			if (!client) {
				this.dialog.open(RegisterOrLoginComponent, {
					width: '375px',
					maxHeight: '90vh',
					autoFocus: false,
					panelClass: 'register-login-dialog-container',
				})
				return
			}
			this.dialog.open(SelectCardOptionsComponent, {
				width: '375px',
				maxHeight: '90vh',
				autoFocus: false,
				panelClass: 'select-card-dialog-container',
			})
		}
	}
}
